import { DivisiResponse } from "../../../../models/Divisi";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";

export async function divisi(DIVISI_ID: number): Promise<DivisiResponse> {
  const res = await ApiClient.get(`/Divisi?DIVISI_ID=${DIVISI_ID}`);
  return res.data[0];
}

export const useFetchDivisi = mutationWrapper(divisi);
